__turbopack_context__.v({
  "buttonContainer": "bI_1eW_buttonContainer",
  "container": "bI_1eW_container",
  "title": "bI_1eW_title",
});
